import { CopytradersTable } from "./components";
import MarketsTablePagination from "@components/pages/Markets/components/MarketsTable/components/MarketsTablePagination";

import "./Copytraders.sass";
import { useState } from "react";

const paginationRange = [
  {
    type: "page",
    value: 1,
  },
  {
    type: "page",
    value: 2,
  },
  {
    type: "page",
    value: 3,
  },
  {
    type: "ellipsis",
    direction: "right",
  },
  {
    type: "page",
    value: 25,
  },
];

export const Copytraders = () => {
  const tabs = ["Leaderboard", "All Traders", "Favorites", "Subscribed"];

  const [activeTab, setActiveTab] = useState(tabs[0]);

  const handlePageChange = () => {
    return;
  };

  const handleEllipsisClick = () => {
    return;
  };

  return (
    <div className="copytraders">
      <ul className="copytraders__switcher">
        {tabs.map((tab) => (
          <li
            key={tab}
            className={`copytraders__switcher-item ${
              activeTab === tab ? "copytraders__switcher-item--active" : ""
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </li>
        ))}
      </ul>

      <CopytradersTable activeMainTab={activeTab} />

      <div className="markets-table__pagination-container">
        <MarketsTablePagination
          paginationRange={paginationRange}
          currentPage={1}
          totalPages={30}
          onPageChange={handlePageChange}
          onEllipsisClick={handleEllipsisClick}
        />
      </div>
    </div>
  );
};
